<template>
	<div class="ui input">
		<span
			v-if="help?.message"
			style="color: #9b5400"
			>{{ help?.message }}</span
		>
		<input
			v-if="mask"
			:id="id"
			v-mask="mask"
			class="form-input"
			:type="type"
			:disabled="disabled"
			:placeholder="placeholder != null ? placeholder : label"
			:value="value"
			:readonly="readonly"
			v-on="inputListeners"
		/>
		<input
			v-else
			:id="id"
			class="form-input"
			:type="type"
			:disabled="disabled"
			:placeholder="placeholder != null ? placeholder : label"
			:value="value"
			:readonly="readonly"
			v-on="inputListeners"
		/>
		<div class="flex gap-1">
			<label
				:disabled="disabled"
				class="form-label"
				:for="id"
				>{{ label }}</label
			>
			<slot />
		</div>
	</div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
	directives: { mask },
	props: {
		/**
		 * Id do componente
		 */
		disabled: Boolean,

		/**
		 * Id do componente
		 */
		id: String,
		/**
		 * Label do componente
		 */
		label: String,
		/**
		 * Placeholder do componente
		 */
		placeholder: String,
		/**
		 * Valor que sera feito o bind
		 */
		value: [String, Number],
		/**
		 * Mascara para o campo
		 */
		mask: [String, Array],

		type: {
			type: String,
			default: 'text',
		},

		readonly: {
			type: Boolean,
			default: false,
		},
		help: {
			type: Object,
			required: false,
		},
	},
	computed: {
		inputListeners: function () {
			var vm = this

			return Object.assign({}, this.$listeners, {
				/**
				 * Adiciona o evento de blur para o componente
				 */
				blur: function (event) {
					if (event.target) {
						vm.$emit('blur', event.target.value)
					}
				},
				/**
				 * Para funcionar o v-model
				 */
				input: function (event) {
					if (event.target) {
						vm.$emit('input', event.target.value)
					}
				},
				/**
				 * Evento para recuperar valor quando digitar no teclado
				 */
				keyup: function (event) {
					if (event.target) {
						vm.$emit('keyup', event.target.value)
					}
				},
			})
		},
	},
}
</script>

<style scoped>
.ui.input {
	flex-direction: column-reverse;
	width: 100%;
	margin-bottom: 0.1rem;
}

.form-input {
	font-size: 0.75rem;
}

.form-label {
	font-size: 0.75rem;
}
</style>
